export var IPublicModelDragObject = function IPublicModelDragObject() {};